<template>
  <div class="row">
    <enter-termination-objects-table
      :objects-with-same-tenants="objectsWithSameTenants"
      :same-tenancies-by-object="sameTenanciesByObject"
      :object-id="objectId"
      @selected-object="selectedObject" />
  </div>
</template>

<script>
import EnterTerminationObjectsTable from '@/enterTermination/component/EnterTerminationObjectsTable'

export default {
  name: 'EnterTerminationOtherTenancies',
  components: {
    EnterTerminationObjectsTable
  },
  props: {
    objectsWithSameTenants: {
      type: Array,
      required: true
    },
    sameTenanciesByObject: {
      type: Array,
      required: true
    },
    objectId: {
      type: String,
      required: true
    }
  },
  methods: {
    selectedObject(object) {
      this.$emit('selected-object', object)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
